import { useMemo } from 'react';

import { useMatches } from '@tanstack/react-router';

import type { IBlock } from '@dcentralexpedientedigital/fe-shared/types/config.interface';

export enum LayoutComponents {
    TopNavigation = 'TopNavigation',
    SideNavigation = 'SideNavigation',
    BottomNavigation = 'BottomNavigation',
    Footer = 'Footer',
}

export interface LayoutDeclaration {
    name: string;
    description: string;
    components: LayoutComponents[];
    theme: string;
    props?: {
        variant?: 'padded' | 'contained';
        maxWidth?: number | undefined;
    };
    modal?: {
        type?: 'popup' | 'drawer';
    };
}

interface LayoutStaticData {
    isLayout: true;
    declaration: LayoutDeclaration;
    configuration: Record<LayoutComponents, IBlock[]>;
}

export function isLayoutDeclaration(definition: unknown): definition is LayoutStaticData {
    return (
        !!definition &&
        typeof definition === 'object' &&
        'isLayout' in definition &&
        definition.isLayout === true
    );
}

export function useLayout() {
    const matches = useMatches();
    return useMemo(
        () =>
            matches.find(({ staticData }) => isLayoutDeclaration(staticData))
                ?.staticData as LayoutStaticData,
        [matches],
    );
}
